


































import Vue from 'vue'
import authService from '@/modules/auth/services/authService'
import validationMixin from '@/modules/common/components/form/validationMixin'
import vForm from '@/modules/common/components/form/vForm.vue'
import loading from '@/modules/common/components/loading.vue'
import textField from '@/modules/common/components/form/textField.vue'
import Component from 'vue-class-component'
import notificationService from '@/modules/common/services/notificationService'

@Component({
  components: { vForm, textField, loading },
  mixins: [validationMixin]
})
export default class Login extends Vue {
  credentials = { username: '', password: '', captchaToken: '' }

  async onSubmit () {
    await this.$store.dispatch('app/loadingDataEnable', 'login')

    const response = await authService.login(this.credentials)

    await this.$store.dispatch('app/loadingDataDisable', 'login')

    if (response) {
      await this.$router.push(authService.mainPath(this.$router.currentRoute))
    } else {
      notificationService.error('error.auth.login')
    }
  }
}
